<template>
    <svg :style="iconColor" @click="toggle" id="icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
         viewBox="0 0 24 24">
        <path :fill="color"
              d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"/>
    </svg>
</template>

<script>
    export default {
        name: "OpenIcon",
        props: {
            color: {
                type: String,
                default: "#000300"
            }
        },
        data() {
            return {
                isOpen: false
            }
        },
        computed: {
            iconColor() {
                return {
                    transform: `rotateZ(${this.rotation}deg)`,
                    transition: `0.2s ease-out !important`,
                    '-webkit-transition': `0.2s ease-out !important`,
                    '-o-transition': `0.2s ease-out !important`,
                    '-moz-transition': `0.2s ease-out !important`,
                    cursor: `pointer`,
                };
            },
            rotation() {
                if (this.isOpen)
                    return 0
                else
                    return -45
            }
        },
        methods: {
            toggle() {
                this.isOpen = !this.isOpen
                return this.$parent.$emit('is-expanded', this.isOpen)
            },
        }
    }
</script>

<style lang="scss" src="../../styles/icons/openicon.scss" scoped/>